import {IsoDate, IsoDateTime} from "../../pseudo-types/DateTypes";

export interface TradeIdeasRecord {
    readonly ironCondors: ReadonlyArray<IronCondorTradeIdeaRecord>;
}

export type TradeIdeaRecords = ReadonlyArray<TradeIdeaRecord>;

export interface TradeIdeaRecord {
    readonly name: string;
    readonly asAt: IsoDateTime;
    readonly underlying: string;
    readonly confidence: number;
    readonly expiry: IsoDate;
    readonly currentPrice: number;
    readonly targetPrice: number | null;
    readonly marketMade: boolean;
    readonly risk: TradeIdeaRiskRecord;
    readonly type: TradingIdeaType;
}

export interface TradeIdeaRiskRecord {
    readonly risk: number;
    readonly payoff: number;
}

export enum TradingIdeaType {
    IRON_CONDOR = "IRON_CONDOR"
}

export interface IronCondorTradeIdeaRecord extends TradeIdeaRecord {
    readonly type: TradingIdeaType.IRON_CONDOR;
    readonly boughtPut: IronCondorLeg;
    readonly soldPut: IronCondorLeg;
    readonly soldCall: IronCondorLeg;
    readonly boughtCall: IronCondorLeg;
    readonly lowerBreakEven: number | null;
    readonly upperBreakEven: number | null;
}

export interface IronCondorLeg {
    readonly code: string;
    readonly strike: number;
}

export function isIronCondorIdea(record: TradeIdeaRecord): record is IronCondorTradeIdeaRecord {
    return record.type === TradingIdeaType.IRON_CONDOR;
}
